import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a1218b4&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1218b4')) {
      api.createRecord('0a1218b4', component.options)
    } else {
      api.reload('0a1218b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a1218b4&", function () {
      api.rerender('0a1218b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/shame-mark/index.vue"
export default component.exports